<template>
<div>

  <b-breadcrumb class="d-none d-lg-flex">
    <b-breadcrumb-item>Administratie</b-breadcrumb-item>
    <b-breadcrumb-item active>Bigfox</b-breadcrumb-item>
  </b-breadcrumb>

  <h2 class="d-none d-lg-block">Bigfox</h2>

  <table-wrap :items="devices.nodes" :query="$options.query" :fields="$options.fields" small striped hover table-class="device-list">

    <template v-slot:cell(status)="row">
      <template v-if="row.item.status === 'ONLINE'">
        <span class="mdi mdi-network-outline text-success"> Online</span>
      </template>
      <template v-else>
        <span class="mdi mdi-network-off-outline text-danger"> Offline</span>
      </template>
    </template>
    <template #cell(updated)="{value}">{{value|format_duration($store.state.now)}}</template>

    <template v-slot:cell(actions)="row">
      <b-btn variant="danger" size="sm" @click="deleteDevice(row)"><span class="mdi mdi-delete"/> Verwijder</b-btn>
<!--      <b-btn variant="primary" size="sm" class="ml-1" @click="discovery(row.item)">
        <span class="mdi mdi-map-search-outline"/> Printers zoeken</b-btn>-->
      <b-btn variant="primary" size="sm" class="ml-1" @click="objToManage = row.item.id; showManage = true"><span class="mdi mdi-cog"/> Beheren</b-btn>
      <b-btn variant="primary" size="sm" class="ml-1" :to="`/main/admin/bigfox/view/${row.item.id}`">
        <span class="mdi mdi-eye-outline"/> Bekijken
      </b-btn>
    </template>
  </table-wrap>

  <b-modal centered title="Beheren" v-model="showManage">
    <manage-device :id="objToManage" ref="manageDev" />
    <template v-slot:modal-footer="{ok, cancel}">
      <b-btn @click="cancel">Annuleer</b-btn>
      <b-btn @click="$refs.manageDev.save(ok)" variant="primary">Opslaan</b-btn>
    </template>
  </b-modal>

</div>
</template>

<script>

import discovery from '../../lib/discovery';
import TableWrap from '@/components/TableWrap';
import coerce_bool_computed from '@/lib/coerce_bool_computed';
import ManageDevice from '@/components/ManageDevice';

export default
{
    components: {TableWrap, ManageDevice},
    data()
    {
        return {
            deleteId: null,
            devices: {},
            objToManage: null,
            showManage: false
        }
    },
    methods:
    {
        async deleteDevice(row)
        {
            const response = await this.$bvModal.msgBoxConfirm('Ben je zeker dat je dit wil verwijderen?',
                {
                    title: 'Bigfox verwijderen',
                    okTitle: 'Verwijder',
                    okVariant: 'danger',
                    centered: true,
                    cancelTitle: 'Niet verwijderen',
                    cancelVariant: 'info'
                }
            );

            if(!response)
                return;

            return this.$apollo.mutate(
                {
                    mutation: require('../../graphql/deleteDevice.mutation.gql'),
                    variables: { id: row.item.id }
                }
            );
        },
        discovery
    },
    fields:
    [
        {
            key: 'deviceId'
        },
        {
            key: 'displayName',
            label: 'Naam',
            sortable: true,
            sort: 'DISPLAY_NAME',
            search: 'STRING'
        },
        {
            key: 'internalName',
            label: 'Interne naam',
            search: 'STRING'
        },
        {
            key: 'serial',
            label: 'Serienummer',
            search: 'STRING'
        },
        {
            key: 'fwVer',
            label: 'Firmware'
        },
        {
            key: 'status',
            tdClass: 'text-nowrap',
            sort: 'STATUS',
            sortable: true,
            search: 'ENUM',
            values: ['ONLINE', 'OFFLINE']
        },
        {
            key: 'updated',
            label: 'Laatste update',
            tdClass: 'text-nowrap',
            sort: 'UPDATED',
            sortable: true
        },
        {
            key: 'printers.totalCount',
            label: 'Printers',
            thClass: 'text-right',
            tdClass: 'text-right',
            sort: 'PRINTERS_BY_DEVICE_ID__COUNT',
            sortable: true
        },
        {
            key: 'actions',
            label: 'Acties',
            thClass: 'text-right',
            tdClass: 'text-right text-nowrap'
        }
    ],
    query: require('../../graphql/listDevices.sub.gql')
}
</script>
<style>
table.device-list { table-layout: fixed }
table.device-list th:nth-child(1) { width: 6em; } /* device id */
table.device-list th:nth-child(2) { width: 15%; } /* Name */
table.device-list th:nth-child(3) { width: 20%; } /* Internal name */
table.device-list th:nth-child(4) { width: 9em; } /* Serial */
table.device-list th:nth-child(5) { width: 5em; } /* Firmware */
table.device-list th:nth-child(6) { width: 6em; } /* Status */
table.device-list th:nth-child(7) { width: 9em; } /* Last update */
table.device-list th:nth-child(8) { width: 6em; } /* Printers */
table.device-list th:nth-child(9) { width: 15em; } /* Actions */

</style>